<section class="kb-gallery-manager">
    <div class="kb-gm-previewer">
        <div *ngIf="this.selectedImageName !== ''" class="kb-gm-image">
            <img [src]="SelectImage.Path" [alt]="SelectImage.FileName">
        </div>
        <div *ngIf="this.selectedImageName === ''" class="kb-gm-image">
            Select an image to preview
        </div>
    </div>
    <div class="kb-gm-controls">
        <div class="form-group directory-controls-group">
            <label>
                <span translate>Select a Folder</span>
            </label>
            <div class="directory-controls">
                <p-select [options]="folderList" [(ngModel)]="folderId" (onChange)="BindImageList()"
                    #imgFolderDropdown [style]="{'width':'100%'}"></p-select>
            </div>
            <button  title="Add" type="submit" (click)="saveAndCreateNew()" class="kuba-icon-btn kuba-icon-btn--primary kuba-icon-btn--row">
            <i class="pi pi-plus"></i>
          </button>
            <button  title="Delete" [disabled]="DeleteFolderValidation()"
                (click)="DeleteImageFolder()" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
        </div>
        <div class="form-group" *ngIf="imageList">
            <label>
                <span translate>Files</span>
            </label>
            <input class="form-control manuals-search" [(ngModel)]="filterText" placeholder="Search file">
            <div class="files-list">
                <label>
                    <span translate>Select a File</span>
                </label>
                <div class="list-item " *ngFor="let item of imageList | searchlist:'FileName':filterText">
                    <a href="javascript:void(0);" class="file-name" (click)="PreviewImage(item)">{{item.FileName}}</a>
                    <span class="file-actions">
                        <button  title="Rename" (click)="ShowRename(item)" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-pencil"></i>
          </button>
                        <button  title="Delete" type="submit"
                            (click)="DeleteImageFile()" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
                    </span>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="form-group">
                <div class="upload-file-container">
                    <label translate>Image</label>
                    <div class="upload-actions">
                        <input type="file" id="files" class="hidden" (change)="filesSelectForCoverImage($event)" />
                        <label for="files" class="btn btn-outline-primary" translate>Upload New Image</label>
                    </div>
                    <div *ngIf="uploadStartForCoverImage">
                        <span translate>Image Uploading...</span>
                    </div>
                </div>

                <button [disabled]="SelectedImageValidation()" class="btn btn-primary" type="submit" (click)="upload()">
                    <span translate>Select Image</span>
                </button>
                <button class="btn btn-outline-secondary" type="submit" (click)="Cancle()">
                    <span translate>Cancel</span>
                </button>
            </div>
        </div>
        <p-dialog header="Add folder" [(visible)]="display"  [style]="{width: '350px'}" [resizable]="false" [draggable]="false"
            [baseZIndex]="10000">
            <input class="form-control" [(ngModel)]="newFolderName">
            <ng-template pTemplate="footer">
                <button type="button" class="btn btn-primary" [disabled]="ValidateAddFolderText()"
                    (click)="NewFolder()">Add
                    Folder
                </button>
                <button type="button" class="btn btn-outline-secondary" (click)="CloseFolderDialogBox()">Cancel</button>
            </ng-template>
        </p-dialog>
        <p-dialog header="Rename Image" [(visible)]="displayImage"  [style]="{width: '350px'}" [resizable]="false" [draggable]="false"
            [baseZIndex]="10000">
            <input class="form-control" [(ngModel)]="selectedImageName">
            <ng-template pTemplate="footer">
                <button type="button" [disabled]="ValidateRenameText()" (click)="RenameImage()"
                    class="btn btn-primary">Rename</button>
                <button type="button" (click)="CloseRenameDialogBox()" (click)="Test()"
                    class="btn btn-outline-secondary">Cancel</button>
            </ng-template>
        </p-dialog>
    </div>
</section>